import studentCamryn from '@/public/images/student-testimonial-camryn.jpg'
import studentKaren from '@/public/images/student-testimonial-karen.jpg'
import studentRaul from '@/public/images/student-testimonial-raul.jpg'

// "Students, in their own words." (Phase 6): the three student stories the
// redesign showed on /experience and /employers, copied here with their
// photos from the retired campus-redesign-v1 experiment (removed in Phase 7).
// The quote is the redesign's words without its quotation marks:
// TestimonialCarousel sets no quote mark (Phase 4 Q5). Read these through
// `studentStorySlides`; never retype a quote in a page.

/**
 * @typedef {object} StudentStory
 * @property {string} name
 * @property {string} attribution
 * @property {string} quote
 * @property {import('next/image').StaticImageData} photo
 */

/** @type {readonly StudentStory[]} */
export const STUDENT_STORIES = Object.freeze([
  {
    name: 'Raul N.',
    attribution: 'Class of 2024',
    quote:
      'Campus set me up for success from day one. The support, resources, and sense of teamwork made me feel like no one gets left behind.',
    photo: studentRaul,
  },
  {
    name: 'Karen A.',
    attribution: 'Campus Student',
    quote: "It started as a ‘Sure, why not?’ — now I'm all in.",
    photo: studentKaren,
  },
  {
    name: 'Camryn',
    attribution: 'Class of 2024',
    quote:
      'My success coach was my biggest resource — always checking in and cheering me on. We have a personal connection — it never felt like I was just a number.',
    photo: studentCamryn,
  },
])

/**
 * The stories as Helios TestimonialCarousel slides: the byline is the name
 * and the attribution, the photo's alt the name (as the redesign's).
 *
 * @param {readonly StudentStory[]} [stories]
 */
export function studentStorySlides(stories = STUDENT_STORIES) {
  return stories.map(story => ({
    quote: story.quote,
    byline: `${story.name}, ${story.attribution}`,
    photo: story.photo,
    photoAlt: story.name,
  }))
}
